import React from "react";
import { LogoImage, LogoImageRight } from "customizations";
import { User } from "api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const currentPath = window.location.hash || window.location.pathname;
  if (currentPath.includes('/embed-calendar') || currentPath.includes('/large-screen') || currentPath.includes('/touch-screen')) return null;
  const formatUrl = (url) => {
    if (!url) return null;
    return url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
  };

  const renderLogo = () => {
    const logoUrl = User?.current?.logoUrl;

    if (!logoUrl || logoUrl === "null") {
      return (
        <a href="/">
          <img className="main-logo" src={LogoImage} alt="Company Logo" />
        </a>
      );
    }

    return (
      <a href="/">
        <img className="main-logo" src={logoUrl} alt="Company Logo" />
      </a>
    );
  };

  return (
    <footer className="bg-white py-4 border-top mt-5">
      <div className="container text-center">
        <div className="d-flex flex-column align-items-center">
          <div className="d-flex align-items-center mb-3">
            <span className="navbar-text sidebar d-flex align-items-center">
              <img 
                width="36" 
                height="36" 
                src={User.current && !User.current.isGuestExperience ? (User.current.picture || LogoImageRight) : LogoImageRight} 
                className={User.current && !User.current.isGuestExperience ? 'profile-image' : 'app-icon'} 
                alt={User.current?.name ? `${User.current.name}'s profile` : "Profile image"}
              />
            </span>
          </div>
          <p className="text-muted text-center fs-6 fs-md-5" style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>
            {User.homeFeedFooter}
          </p>
          <ul className="list-unstyled d-flex mt-3 justify-content-center align-items-center mb-0" style={{ gap: "3.5rem" }}>
            {User.homeFeedFacebook && (
              <li>
                <a href={formatUrl(User.homeFeedFacebook)} className="text-muted fs-5" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
              </li>
            )}
            {User.homeFeedInstagram && (
              <li>
                <a href={formatUrl(User.homeFeedInstagram)} className="text-muted fs-5" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </li>
            )}
            {User.homeFeedYoutube && (
              <li>
                <a href={formatUrl(User.homeFeedYoutube)} className="text-muted fs-5" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </li>
            )}
          </ul>
        </div>
        <div className="border-top mt-3 pt-3">
          <p className="text-muted text-center mb-0">
            © 2026{" "}
            <a
              href="https://www.alosant.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              Alosant
            </a>{" "}
            All rights reserved.
          </p>
          <p className="text-muted text-center mb-0 mt-2">
            Alosant is committed to providing an accessible experience and follows WCAG 2 accessibility guidelines.<br />
            If you encounter accessibility issues or require support, please contact: <b>accessibility@alosant.com</b>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
